// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.940Z

import {
    GetInviteApiResponse,
    GetInviteApiArg,
    PostInviteApiResponse,
    PostInviteApiArg,
    GetInviteByInviteIdApiResponse,
    GetInviteByInviteIdApiArg,
    PostInviteByInviteIdApiResponse,
    PostInviteByInviteIdApiArg,
    DeleteInviteByInviteIdApiResponse,
    DeleteInviteByInviteIdApiArg,
    GetInviteByInviteIdCheckApiResponse,
    GetInviteByInviteIdCheckApiArg,
    PatchInviteByInviteIdAndInviteActionApiResponse,
    PatchInviteByInviteIdAndInviteActionApiArg
} from "~/api/inviteAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getInvite: build.query<GetInviteApiResponse, GetInviteApiArg>({
            query: (queryArg) => ({
                url: "/invite",
                params: {
                    status: queryArg.status,
                    created: queryArg.created,
                    updated: queryArg.updated,
                    send: queryArg.send,
                    email: queryArg.email,
                    pagination: queryArg.pagination,
                    sort: queryArg.sort,
                },
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        postInvite: build.mutation<PostInviteApiResponse, PostInviteApiArg>({
            query: (queryArg) => ({ url: "/invite", method: "POST", body: queryArg }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getInviteByInviteId: build.query<
            GetInviteByInviteIdApiResponse,
            GetInviteByInviteIdApiArg
        >({
            query: (queryArg) => ({ url: `/invite/${queryArg}` }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        postInviteByInviteId: build.mutation<
            PostInviteByInviteIdApiResponse,
            PostInviteByInviteIdApiArg
        >({
            query: (queryArg) => ({
                url: `/invite/${queryArg["invite-id"]}`,
                method: "POST",
                body: queryArg.invitePutInviteRequest,
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        deleteInviteByInviteId: build.mutation<
            DeleteInviteByInviteIdApiResponse,
            DeleteInviteByInviteIdApiArg
        >({
            query: (queryArg) => ({ url: `/invite/${queryArg}`, method: "DELETE" }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getInviteByInviteIdCheck: build.query<
            GetInviteByInviteIdCheckApiResponse,
            GetInviteByInviteIdCheckApiArg
        >({
            query: (queryArg) => ({
                url: `/invite/${queryArg["invite-id"]}/check`,
                params: {email: queryArg.email},
            }),
        }),
        patchInviteByInviteIdAndInviteAction: build.mutation<
            PatchInviteByInviteIdAndInviteActionApiResponse,
            PatchInviteByInviteIdAndInviteActionApiArg
        >({
            query: (queryArg) => ({
                url: `/invite/${queryArg["invite-id"]}/${queryArg["invite-action"]}`,
                method: "PATCH",
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as inviteAPI };
export const {
    useGetInviteQuery,
    useLazyGetInviteQuery,
    usePostInviteMutation,
    useGetInviteByInviteIdQuery,
    useLazyGetInviteByInviteIdQuery,
    usePostInviteByInviteIdMutation,
    useDeleteInviteByInviteIdMutation,
    useGetInviteByInviteIdCheckQuery,
    useLazyGetInviteByInviteIdCheckQuery,
    usePatchInviteByInviteIdAndInviteActionMutation,
} = injectedRtkApi;
